import ImgOffice from 'assets/images/content/frauencoach-office.jpg'
import { Button, Col, Container, OfficeMap, Row, Section } from 'atoms'
import Image from 'next/image'
import { ContactCard } from 'organisms'
import { FC } from 'react'

import Styles from './Service.module.sass'

const Service: FC<unknown> = () => (
  <>
    <Section background="rose">
      <Container>
        <h1>
          Anfahrt und Service
        </h1>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <p>
              {`Mein Büro liegt absolut zentral in Berlin-Mitte und ist dennoch ein ruhiger und individueller Rückzugsort.`}
            </p>
            <p>
              Anfahrt ganz leicht und schnell.
            </p>
            <hr/>
            <h4>Mit dem Auto</h4>
            <p>
              Steinstraße 15<br/>
              10119 Berlin<br/>
              Parkplätze sind mit etwas Geduld zu finden.<br/>
              Tel: 0176 20171385
            </p>
            <hr/>
            <h4>Mit den öffentlichen Verkehrsmitteln</h4>
            <ul>
              <li>
                {`Mit der S-Bahn bis zum Bahnhof Hackescher Markt, ca 7 Minuten Fußweg.`}
              </li>
            </ul>
            <p>
              oder
            </p>
            <ul>
              <li>
                {`Mit der U2 bis zum Bahnhof Rosa-Luxemburg-Platz und 5 Minuten Fußweg.`}
              </li>
              <li>
                {`Mit der U8 bis zum Bahnhof Rosenthaler Platz oder bis zum Bahnhof Weinmeisterstraße und jeweils 5 Minuten Fußweg.`}
              </li>
            </ul>
            <br/>
          </Col>
          <Col xs={12} md={6}>
            <Image
              alt="FrauenCoach Praxis / Büro"
              src={ImgOffice}
              placeholder="blur"
            />
            <br/>
            <Button block theme="gray" href="/angebot-privatpersonen">
              Angebote für Privatpersonen
            </Button>
            <Button block theme="gray" href="/angebot-firmen">
              Angebote für Firmen
            </Button>
            <Button block theme="gray" href="/angebot-privatpersonen/angebote-fuer-senioren">
              Angebote für Seniorinnen
            </Button>
            <Button block theme="gray" href="/angebot-privatpersonen/ratung-und-therapie-hpg-berlin-mitte">
              Beratung und Therapie (HPG)
            </Button>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section className={Styles.sectionMap}>
      <OfficeMap />
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
  </>
)

export default Service
